import React, { useState, useEffect } from 'react';
import { Form, Input, Spin, AutoComplete, Typography, Row, Col, Space } from 'antd';
import { useAppContext } from './AppContext';
import axios from 'axios';
import { workerURL } from '../Config';
const { Search } = Input;
const { Text } = Typography;


const ManagerDetail = () => {
  const [employeeData, setEmployeeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const { isAdmin, mailID, setMailID, setUpName, upName,accessToken,idToken } = useAppContext();


  const handleSearch = async (value) => {
    //if (isAdmin) {
      setSearchTerm(value);
      setLoading(true);
      //console.log('Access Token:', accessToken);
      //console.log('URL:', `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${value}')`);
      const url = `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${value}')`;
      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}` // Include access token in headers
          }
        });
        //console.log('response:', response);
        setSearchResults(response.data.value.map(user => ({ value: user.displayName, user })));
      } catch (error) {
        //console.error('Error fetching user data:', error);
      } finally {
        setLoading(false);
      }

    //}
  };

  const handleSelect = (value, option) => {
    //console.log('Selected user email:', option.user.mail);
    //console.log('Selected user principal name:', option.user.userPrincipalName);    
    setMailID(option.user.mail);
    setUpName(option.user.userPrincipalName);
  };

  useEffect(() => {
    setLoading(true);
    //console.log('Mail:', mailID);
    fetch(workerURL + `/${upName}`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`  // Include the bearer token here
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.json();
      })
      .then(data => {
        setEmployeeData(data);
        setLoading(false);
      })
      .catch(error => {
        //console.error('Error fetching data:', error);
        setLoading(false);
      });

  }, [upName]);

  return (
    <Spin size="large" spinning={loading}>
      <Space>
        <div>
          <div>
            <AutoComplete
              placeholder="Search the Functional Leader"
              options={searchResults}
              onSearch={handleSearch}
              onSelect={handleSelect}
              style={{
                width: 400,
              }}
            />
          </div>
          <br></br>
          <div>
            <Text style={{ fontWeight: 'bold', fontSize: 18 }}>{employeeData?.userName}</Text>
            <br></br>
            <Text style={{ fontSize: 15 }}>{employeeData?.jobTitle}</Text>
          </div>
          <br></br>
          <div>
            <Row gutter={16}>
              <Col span={12}>
                <Text style={{ fontSize: 14 }}>Executive Leader</Text>
                <br></br>
                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{employeeData?.functionalLeader}</Text>
              </Col>
              <Col span={12}>
                <Text style={{ fontSize: 14 }}>Manager</Text>
                <br></br>
                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{employeeData?.managerName}</Text>
              </Col>
            </Row>
            <br></br>
            <Row gutter={16}>
              <Col span={12}>
                <Text style={{ fontSize: 14 }}>Development RollUp</Text>
                <br></br>
                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{employeeData?.departmentRollUp}</Text>
              </Col>
              <Col span={12}>
                <Text style={{ fontSize: 14 }}>Department</Text>
                <br></br>
                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{employeeData?.department}</Text>
              </Col>
            </Row>
            <br></br>
            <Row gutter={16}>
              <Col span={12}>
                <Text style={{ fontSize: 14 }}>Location</Text>
                <br></br>
                <Text style={{ fontWeight: 'bold', fontSize: 14 }}>{employeeData?.location}</Text>
              </Col>
            </Row>
          </div>
        </div>
        
      </Space>
    </Spin>
  );
};

export default ManagerDetail;
